<template>
  <div class="about_us">
    <div class="about_us_banner">
      <img src="@/assets/img/about_us/bg.jpg" alt />
    </div>
    <div class="about_content">
      <div class="m about_box">
        <div class="about_content_l">
          <img src="@/assets/img/about_us/logoB.png" alt />
        </div>
        <div class="about_content_r">
          <h3>关于我们</h3>
          <p>在展平台联合高校打造全方位、多角度、综合性的数字展示专业媒体；</p>
          <p>24小时全天候随时随地永久观展，打造永不落幕的线上设计展览；</p>
          <p>大数据精准推荐最新最热明日之星，辐射专业院校直观直接搜寻沧海遗珠；</p>
          <p>数字化全面展示优秀展品，自主便捷操作，不放过任何艺术细节。</p>
          <p>明星院校创作团队娓娓道来，全面剖析作品背后的创作意义与故事。</p>
          <p class="mt20">在展平台以构建虚拟展览和提供作品版权服务为服务方向，打造设计师专属展览平台；</p>
          <p>在展平台将为多家院校和企业联系在一起，构建设计类人才输送平台；</p>
          <p>在展平台只享有作者作品的展示权，作品的所有权、修改权、著名权等一律权利归作者本人所有。</p>
          <p class="mt20">
            <i class="icon iconfont">&#xe603;</i>电话：+86 757 81856675
          </p>
          <p>
            <i class="el-icon-location-outline"></i>&nbsp;地址：中国 广东省佛山市南海区桂城瀚天科技城A5号楼一号门六楼
          </p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.about_us {
    .mt20{
        margin-top: 20px;
    }
  .about_us_banner {
    height: 350px;
    background: #f0f0f0;
    img {
      object-fit: contain;
      height: 350px;
      width: 100%;
    }
  }
  .about_content {

      padding: 90px 0 100px;
    background-color: #fff;
    .about_box{
      display: flex;
      align-items: center;
    }
    .about_content_l {
        width: 636px;
        img {
          width: 423px;
      }
    }
    .about_content_r {
      h3 {
        font-size: 22px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 62px;
      }
      p {
          font-size:14px;
          line-height: 24px;
          i{
              width: auto;
              height: auto;
          }
      }
    }
  }
}
</style>
